import React from "react";

export default function Viewport({ children }) {
  return <div style={{ height: "calc(100vh - 85px)", width: "calc(100vw - 350px)" }}>{children}</div>;
}
